/* eslint-disable react/prop-types */
/* eslint-disable no-shadow */
/* eslint-disable react/jsx-props-no-spreading */
import React, {
  useState, useEffect, useCallback,
} from 'react';
import { compose, bindActionCreators } from 'redux';
import { Form, Field, withFormik } from 'formik';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';

import {
  Form as SemanticForm,
  Container,
  Grid as SemanticGrid,
  Loader,
  Popup,
} from 'semantic-ui-react';
import { captureException, InputFormField, withTranslation } from '@playbookux/playbook-web-core';
import { useQuery } from '@apollo/client';
import Categorizing from '../../../core/components/categorizing-select-list';
import MaskedFormField from '../../../core/components/masked-form-field';
import SelectFormField from '../../../core/components/select-form-field';
import ButtonSelectFormField from '../../../core/components/button-select-form-field';
import withLayout from '../../../core/components/with-layout';

import {
  seniority,
  companySize,
  industry,
  educationLevelOptions,
} from '../../../admin/pages/edit-tester/options';

import schema from './schema';
import {
  ErrorMessage,
  FullWidth,
  Heading,
  Main,
  PaymentMethodContainer,
  SignUpButton,
  SubHeading,
  Text,
  TextHeader,
  FixedButtonContainer,
  WrapperCountry,
  Icon,
} from './styles';

import { MINIMUM_AGE, MINIMUM_AGE_ERROR } from './constants';

import { patchProfile, getCurrentProfile, signOut } from '../../../core/actions';

import {
  annualHouseholdIncomeOptions,
  countryOptions,
  stateOptions,
  genderOptions,
  raceEthnicHeritageOptions,
  workStatusOptions,
  smartphone,
  computer,
  tablet,
  languages,
} from './options';
import { GET_PROFILE_ATTRIBUTES } from '../profile-summary/graphql';
import { useJobsList } from '../../../core/hooks/use-jobs-list';

const SignUpSurvey = (props) => {
  const {
    handleSubmit,
    status,
    profile: profileState,
    errors,
    touched,
    setFieldValue,
    history,
    setValues,
    location: { pathname },
    phrases,
  } = props;

  const [showErrors, setShowErrors] = useState(false);

  const { data = {}, error, loading } = useQuery(GET_PROFILE_ATTRIBUTES, {
    variables: {
      userId: profileState.user_id,
    },
  });

  const { valuesCatJobs, jobsSelected } = useJobsList(data);

  const callbackCatAndSubCat = useCallback((items, type) => {
    if (type === 'jobs') {
      setFieldValue('jobsSelected', items.map((item) => item.id));
    }
  }, [setFieldValue]);

  useEffect(() => {
    const { location: { state: locationState = null } } = props;
    if (!(locationState && locationState.prevPage && locationState.prevPage.pathname === '/profile-summary')) {
      history.push('/profile-summary');
    }

    // set the values to the response of the async function getJobList
  }, [history, props, data]);

  useEffect(() => {
    const { user = {} } = data;
    const { profile: signUpProfile } = user;
    if (!_.isEmpty(signUpProfile)) {
      const {
        firstName,
        lastName,
        email,
        birthdate,
        computer,
        currentPosition,
        educationLevel,
        jobCategories,
        languages,
        smartphone,
        tablet,
        workStatus,
        raceEthnicHeritage,
        annualHouseholdIncome,
        country,
        state,
        gender,
        browsers,
        otherDevices,
        webExpertise,
        paypalAccount,
        phoneNumber,
      } = signUpProfile;

      const profileRoute = pathname === '/profile';
      const [date] = birthdate ? birthdate.split('T') : '';
      const [year, month, day] = date ? date.split('-') : [];

      if (profileRoute) {
        setValues({
          email,
          firstName,
          lastName,
          educationLevel,
          languages: languages || [],
          birthdateMonth: month,
          birthdateDay: day,
          birthdateYear: year,
          gender,
          raceEthnicHeritage,
          workStatus: workStatus || [],
          annualHouseholdIncome,
          webExpertise,
          browsers: browsers || [],
          smartphone: smartphone || [],
          computer: computer || [],
          tablet: tablet || [],
          otherDevices: otherDevices || [],
          state: state || '',
          country,
          jobsSelected: jobCategories || [],
          paypalAccount: (paypalAccount === '') ? email : paypalAccount,
          currentPosition: currentPosition ? ({
            title: currentPosition.title,
            seniority: currentPosition.seniority,
            company: currentPosition.company,
          }) : ({
            title: '',
            seniority: '',
            company: {
              size: '',
              industry: '',
            },
          }),
          lastEdition: new Date(),
          phoneNumber,
        });
      }
    }
  }, [data]);

  if (error) {
    return (
      <ErrorMessage>
        {status.message || 'Error retrieving profile information. Please try again.'}
      </ErrorMessage>
    );
  }

  if (loading) {
    return <Loader data-loader="sign-up-survey-loader" />;
  }

  const hasCountry = data?.user?.profile?.country;
  const selectedCountry = !_.isEmpty(hasCountry) ? countryOptions.find((val) => val.value === hasCountry) : {};
  if (selectedCountry && selectedCountry.value && profileState) {
    profileState.country = selectedCountry.value;
  }

  const renderButton = (pathname, handleSubmit) => {
    if (pathname !== '/profile') {
      return (
        <FullWidth>
          <SemanticGrid centered>
            <SignUpButton
              onClick={(e) => {
                setShowErrors(true);
                handleSubmit(e);
              }}
              type="submit"
            >
              Sign Up
            </SignUpButton>
          </SemanticGrid>
        </FullWidth>
      );
    }

    return (
      <FixedButtonContainer>
        <SignUpButton
          onClick={(e) => {
            setShowErrors(true);
            handleSubmit(e);
          }}
          type="submit"
        >
          Save My Profile
        </SignUpButton>
      </FixedButtonContainer>
    );
  };

  if (status && status.isLoading) {
    return (
      <div>
        <SemanticGrid container verticalAlign="middle">
          <Loader active data-loader="status-loader" />
        </SemanticGrid>
      </div>
    );
  }

  const paypalAccountNotUnique = () => {
    if (status.code === 'paypal_account_not_unique') {
      return {
        errors: { paypalAccount: true },
        touched: { paypalAccount: true },
        setFieldValue,
      };
    }
    return {
      errors,
      touched,
      setFieldValue,
    };
  };

  if (pathname === '/sign-up/survey') {
    return (
      <Main>
        <TextHeader>
          Profile information has already been filled. Thank you!
        </TextHeader>
      </Main>
    );
  }

  const remapErrors = _.cloneDeep(errors);

  const { currentPosition = {} } = remapErrors;
  const { company = {} } = currentPosition;
  delete remapErrors.currentPosition;

  const errorsKeys = _.keys({ ...remapErrors, ...currentPosition, ...company }).map((item) => {
    if (item === 'birthdateMonth' || item === 'birthdateDay' || item === 'birthdateYear') {
      return 'Date of Birth';
    }
    if (item === 'jobsSelected') {
      return 'Job Roles';
    }
    if (item === 'raceEthnicHeritage') {
      return 'Ethnicity';
    }
    if (item === 'title') {
      return 'Job title';
    }
    if (item === 'size') {
      return 'Company size';
    }
    return _.startCase(item);
  });

  let errorMessage = '';
  if (_.uniq(errorsKeys).length === 1) {
    errorMessage = `Please enter your ${errorsKeys[0]}.`;
  } else if (_.uniq(errorsKeys).length > 1) {
    const errorsExceptLast = _.dropRight(_.uniq(errorsKeys)).join(', ');
    errorMessage = `Please enter your ${errorsExceptLast} and ${errorsKeys[errorsKeys.length - 1]}.`;
  }

  return (
    <Main>
      <Container>
        {status && status.error && status.code !== 'paypal_account_not_unique' && (
          <ErrorMessage>
            {status.message || 'Error while sending profile information. Please try again.'}
          </ErrorMessage>
        )}

        <Heading>
          We&apos;ll use your profile information to match you with tests.
        </Heading>

        <SubHeading>
          Estimated time to complete: 2 minutes
        </SubHeading>

        <Form>
          <SemanticForm as="div">
            <Field
              labelText={phrases.scheduler_confirm_email}
              name="email"
              placeholder="hello@playbookux.com"
              labelFontSize="18px"
              labelColor="#172B4D"
              component={InputFormField}
            />
            <Field
              labelText="First name"
              name="firstName"
              placeholder="John"
              labelFontSize="18px"
              labelColor="#172B4D"
              component={InputFormField}
            />
            <Field
              labelText="Last name"
              name="lastName"
              placeholder="Doe"
              labelFontSize="18px"
              labelColor="#172B4D"
              component={InputFormField}
            />
            <SemanticForm.Field>
              <SemanticGrid columns="equal">
                <SemanticGrid.Row>
                  <SemanticGrid.Column>
                    <Field
                      labelText="Birth Date"
                      name="birthdateMonth"
                      mask={[/[0-9]/, /\d/]}
                      placeholder="MM"
                      type="text"
                      labelFontSize="18px"
                      labelColor="#172B4D"
                      component={MaskedFormField}
                    />
                  </SemanticGrid.Column>
                  <SemanticGrid.Column>
                    <Field
                      labelText="&nbsp;"
                      mask={[/[0-9]/, /\d/]}
                      name="birthdateDay"
                      placeholder="DD"
                      type="text"
                      component={MaskedFormField}
                    />
                  </SemanticGrid.Column>
                  <SemanticGrid.Column>
                    <Field
                      labelText="&nbsp;"
                      name="birthdateYear"
                      placeholder="YYYY"
                      type="text"
                      mask={[/[1-9]/, /\d/, /\d/, /\d/]}
                      component={MaskedFormField}
                    />
                  </SemanticGrid.Column>
                </SemanticGrid.Row>
                {(touched.birthdateMonth && touched.birthdateYear && touched.birthdateDay) && errors.birthdateMonth && (
                  <ErrorMessage>{errors.birthdateMonth}</ErrorMessage>
                )}
              </SemanticGrid>
            </SemanticForm.Field>
            <SemanticForm.Field>
              <Field
                labelFontSize="18px"
                label="Gender"
                name="gender"
                isMulti={false}
                isCreatable={false}
                options={genderOptions}
                labelColor="#172B4D"
                component={SelectFormField}
              />
            </SemanticForm.Field>
            <SemanticForm.Field>
              <Field
                labelFontSize="18px"
                label="What is your ethnicity?"
                name="raceEthnicHeritage"
                isMulti={false}
                isCreatable={false}
                options={raceEthnicHeritageOptions}
                labelColor="#172B4D"
                component={SelectFormField}
              />
            </SemanticForm.Field>
            <SemanticForm.Field>
              <Field
                labelFontSize="18px"
                label="What is your employment status? Select all that apply"
                name="workStatus"
                isMulti
                isCreatable={false}
                options={workStatusOptions}
                labelColor="#172B4D"
                component={SelectFormField}
              />
            </SemanticForm.Field>
            <SemanticForm.Field>
              <Field
                labelFontSize="18px"
                label="What is your annual household income in US Dollars?"
                name="annualHouseholdIncome"
                isMulti={false}
                isCreatable={false}
                options={annualHouseholdIncomeOptions}
                labelColor="#172B4D"
                component={SelectFormField}
              />
            </SemanticForm.Field>

            <SemanticForm.Field>
              <Field
                labelText="What is your job title?"
                name="currentPosition.title"
                placeholder="Enter job title"
                labelFontSize="18px"
                labelColor="#172B4D"
                component={InputFormField}
              />
            </SemanticForm.Field>

            <SemanticForm.Field>
              <Field
                labelFontSize="18px"
                label="What is your company size?"
                name="currentPosition.company.size"
                isMulti={false}
                isCreatable={false}
                options={companySize}
                labelColor="#172B4D"
                component={SelectFormField}
              />
            </SemanticForm.Field>

            <SemanticForm.Field>
              <Field
                labelFontSize="18px"
                label="What industry does your company operate in?"
                name="currentPosition.company.industry"
                isMulti={false}
                isCreatable={false}
                options={industry}
                labelColor="#172B4D"
                component={SelectFormField}
              />
            </SemanticForm.Field>

            <SemanticForm.Field>
              <Field
                labelFontSize="18px"
                label="What is your seniority?"
                name="currentPosition.seniority"
                isMulti={false}
                isCreatable={false}
                options={seniority}
                labelColor="#172B4D"
                component={SelectFormField}
              />
            </SemanticForm.Field>

            <SemanticForm.Field>
              <Field
                labelFontSize="18px"
                label="What is your highest level of education?"
                name="educationLevel"
                isMulti={false}
                isCreatable={false}
                options={educationLevelOptions}
                labelColor="#172B4D"
                component={SelectFormField}
              />
            </SemanticForm.Field>

            <SemanticForm.Field>
              <Field
                labelFontSize="18px"
                label="What language(s) do you speak? Select all that apply"
                name="languages"
                isMulti
                isCreatable={false}
                options={languages}
                labelColor="#172B4D"
                component={SelectFormField}
              />
            </SemanticForm.Field>

            <SemanticForm.Field>
              <Field
                labelText="What is your phone number? (optional)"
                name="phoneNumber"
                placeholder="+1 123 456 7890"
                labelFontSize="18px"
                labelColor="#172B4D"
                component={InputFormField}
                info="Receive text messages when you're selected for a study. Please include country code & area code"
              />
            </SemanticForm.Field>

            <SemanticForm.Field>
              <TextHeader>
                Which of the following devices do you own and use?
              </TextHeader>
              <SemanticGrid>
                <SemanticGrid.Row columns={2}>
                  <SemanticGrid.Column>
                    <Field
                      name="smartphone"
                      render={(props) => (
                        (
                          <ButtonSelectFormField
                            {...props}
                            isMulti
                            items={smartphone}
                            label="Smartphone"
                            render={(item) => <p>{item.label}</p>}
                          />
                        )
                      )}
                    />
                  </SemanticGrid.Column>
                  <SemanticGrid.Column>
                    <Field
                      name="computer"
                      render={(props) => (
                        <ButtonSelectFormField
                          {...props}
                          isMulti
                          items={computer}
                          label="Computer"
                          render={(item) => <p>{item.label}</p>}
                        />
                      )}
                    />
                  </SemanticGrid.Column>
                </SemanticGrid.Row>
                <SemanticGrid.Row columns="equal">
                  <SemanticGrid.Column>
                    <Field
                      name="tablet"
                      render={(props) => (
                        <ButtonSelectFormField
                          {...props}
                          isMulti
                          items={tablet}
                          label="Tablet"
                          render={(item) => <p>{item.label}</p>}
                        />
                      )}
                    />
                  </SemanticGrid.Column>
                </SemanticGrid.Row>
              </SemanticGrid>

            </SemanticForm.Field>
            <SemanticForm.Field>
              <WrapperCountry>
                <Field
                  label="Country"
                  name="country"
                  placeholder="Select"
                  isMulti={false}
                  isCreatable={false}
                  options={countryOptions}
                  labelFontSize="18px"
                  labelColor="#172B4D"
                  component={SelectFormField}
                  field={selectedCountry}
                  disabled
                />
                <Popup
                  trigger={<Icon name="question" circular />}
                  content="Please contact tester@playbookux.com to change your country."
                  position="top center"
                />
              </WrapperCountry>
            </SemanticForm.Field>
            {(hasCountry && hasCountry === 'us') && (
              <SemanticForm.Field>
                <Field
                  label="State"
                  name="state"
                  placeholder="Select"
                  isMulti={false}
                  isCreatable={false}
                  options={stateOptions}
                  labelFontSize="18px"
                  labelColor="#172B4D"
                  component={SelectFormField}
                />
              </SemanticForm.Field>
            )}
            <SemanticForm.Field>
              <TextHeader>
                Job Roles
              </TextHeader>
              <Text>
                Which of the below role(s) resembles your job most?
              </Text>
            </SemanticForm.Field>

            <Categorizing
              category={valuesCatJobs}
              callbackCatAndSubCat={callbackCatAndSubCat}
              type="jobs"
              error={touched.jobsSelected && errors.jobsSelected}
              values={jobsSelected}
              isRadioBtn
            />

            <PaymentMethodContainer>
              <Text as="h3" fontSize="14px">
                What PayPal email address should we use to pay you?
                {' '}
                You will be paid within 8 days of completing a session.
              </Text>
              <Field
                name="paypalAccount"
                placeholder="PayPal address"
                component={InputFormField}
                form={paypalAccountNotUnique()}
              />
            </PaymentMethodContainer>
            {status && status.code === 'paypal_account_not_unique'
              && (
                <ErrorMessage>
                  {status.message}
                </ErrorMessage>
              )}
          </SemanticForm>
        </Form>

        <SemanticGrid centered>
          {errors && showErrors
            && (
              <ErrorMessage>
                {errorMessage}
              </ErrorMessage>
            )}
        </SemanticGrid>

        {renderButton(pathname, handleSubmit)}
      </Container>
    </Main>
  );
};

SignUpSurvey.propTypes = {
  me: PropTypes.shape({
    user_id: PropTypes.string,
  }).isRequired,
  onSignOut: PropTypes.func.isRequired,
  profileState: PropTypes.shape({
    id: PropTypes.string,
    user_id: PropTypes.string,
  }).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  status: PropTypes.shape({
    error: PropTypes.bool,
    isLoading: PropTypes.bool,
    message: PropTypes.string,
    code: PropTypes.string,
  }),
  setValues: PropTypes.func.isRequired,
  touched: PropTypes.shape({
    jobsSelected: PropTypes.bool,
    birthdateMonth: PropTypes.bool,
    birthdateDay: PropTypes.bool,
    birthdateYear: PropTypes.bool,
    paypalAccount: PropTypes.bool,
  }).isRequired,
  errors: PropTypes.shape({
    jobsSelected: PropTypes.string,
    birthdateMonth: PropTypes.string,
    paypalAccount: PropTypes.string,
  }).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    state: PropTypes.shape(),
  }).isRequired,
  history: PropTypes.shape().isRequired,
  phrases: PropTypes.shape({
    scheduler_confirm_email: PropTypes.string,
  }).isRequired,
};

SignUpSurvey.defaultProps = {
  status: {
    error: false,
  },
};

const mapStateToProps = ({ authentication }) => ({
  profile: authentication.profile,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  patchProfile,
  getCurrentProfile,
  onSignOut: signOut,
}, dispatch);

export default compose(
  withTranslation,
  withLayout({ selectedTab: 'My Profile' }),
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withFormik({
    validationSchema: schema,
    enableReinitialize: true,
    mapPropsToValues: () => ({
      email: '',
      firstName: '',
      lastName: '',
      educationLevel: '',
      languages: [],
      birthdateMonth: '',
      birthdateDay: '',
      birthdateYear: '',
      gender: '',
      maritalStatus: '',
      payment: '',
      raceEthnicHeritage: '',
      workStatus: [],
      annualHouseholdIncome: '',
      webExpertise: '',
      browsers: [],
      smartphone: [],
      computer: [],
      tablet: [],
      otherDevices: [],
      state: '',
      country: '',
      paymentMethod: 'paypal',
      venmoAccount: '',
      recruitingProgram: false,
      newsletter: false,
      jobsSelected: [],
      paypalAccount: '',
      currentPosition: {},
      lastEdition: new Date(),
      phoneNumber: '',
    }),
    validate: (values) => {
      const errors = {};

      const { birthdateMonth, birthdateDay, birthdateYear } = values;

      if (birthdateMonth && birthdateDay && birthdateYear) {
        const mm = `00${values.birthdateMonth.toString()}`.slice(-2);
        const dd = `00${values.birthdateDay.toString()}`.slice(-2);
        const yyyy = `0000${values.birthdateYear.toString()}`.slice(-4);

        const date = moment(`${yyyy}${mm}${dd}`, 'YYYYMMDD');
        const age = moment().diff(date, 'years');

        if (!date.isValid()) {
          errors.birthdateMonth = 'Invalid Date';
          return errors;
        }

        if (age < MINIMUM_AGE) {
          errors.birthdateMonth = MINIMUM_AGE_ERROR;
          errors.birthdateDay = MINIMUM_AGE_ERROR;
          errors.birthdateYear = MINIMUM_AGE_ERROR;
          return errors;
        }
      }
      return errors;
    },
    handleSubmit: (values, { props, setStatus }) => {
      const mm = `00${values.birthdateMonth.toString()}`.slice(-2);
      const dd = `00${values.birthdateDay.toString()}`.slice(-2);
      const yyyy = `0000${values.birthdateYear.toString()}`.slice(-4);

      const date = moment(`${yyyy}${mm}${dd}`, 'YYYYMMDD').format();
      const { profile: profileState } = props;

      const form = {
        email: values.email,
        lastName: values.lastName,
        firstName: values.firstName,
        birthdate: date,
        gender: values.gender,
        raceEthnicHeritage: values.raceEthnicHeritage,
        workStatus: values.workStatus,
        annualHouseholdIncome: values.annualHouseholdIncome,
        state: (values.country === 'us') ? values.state : '',
        country: values.country,
        jobCategories: values.jobsSelected,
        paymentMethod: 'paypal',
        smartphone: values.smartphone,
        computer: values.computer,
        tablet: values.tablet,
        currentPosition: values.currentPosition,
        paypalAccount: (values.paypalAccount === '') ? values.email : values.paypalAccount,
        recruitingProgram: values.recruitingProgram,
        newsletter: false,
        educationLevel: values.educationLevel,
        languages: values.languages,
        lastEdition: values.lastEdition,
        phoneNumber: values.phoneNumber,
      };

      setStatus({
        isLoading: true,
      });

      props.patchProfile(profileState.id, form)
        .then(() => {
          if (typeof window.fbq === 'function') {
            window.fbq('track', 'Lead');
          }

          return props.getCurrentProfile();
        })
        .then(() => {
          props.history.push('/profile-summary');
        })
        .catch((err) => {
          captureException('SIGN_UP_SURVEY_HANDLE_SUBMIT_FAILED', err);
          setStatus({
            isLoading: false,
            error: true,
            message: err.message,
            code: err.code,
          });
        });
    },
  }),
)(SignUpSurvey);
